import { IRoute, ICrudRoute } from '@interfaces/App.interface';
import { generateCRUDRoutes } from './routes.utils';

//Roles
import ACLPrivilegePage from '@pages/DataBase/Roles/ACLPrivilegePage';
import Roles from '@pages/DataBase/Roles/Roles';
import RolePage from '@pages/DataBase/Roles/RolePage';
import MyRoles from '@pages/DataBase/Roles/MyRoles';
//Users
import UserPage from '@pages/DataBase/Users/UserPage';
//import { NewPasswordForm } from '@ts/storybook';
import Users from '@pages/DataBase/Users/Users';
//Organizations
import Acls from '@pages/DataBase/Organizations/RoleAssignment';
import AclPage from '@pages/DataBase/Organizations/OrganizationAclPage';
import OrganizationPage from '@pages/DataBase/Organizations/OrganizationPage';
import Organizations from '@pages/DataBase/Organizations/Organizations';
import OrganizationStepper from '@pages/DataBase/Organizations/Stepper/OrganizationStepper';

//Tasks
import TaskPage from '@pages/DataBase/Tasks/TaskPage';
import Tasks from '@pages/DataBase/Tasks/Tasks';
import TaskTypePage from '@pages/DataBase/TaskTypes/TaskTypePage';
//Events
import Events from '@pages/DataBase/Events/Events';
import EventPage from '@pages/DataBase/Events/EventPage';
import EventTypePage from '@pages/DataBase/EventTypes/EventTypePage';
import EventGenerationRulePage from '@pages/DataBase/EventGenerationRules/EGRPage';
//Address
import AddressPage from '@pages/DataBase/Addresses/AddressPage';
import AppProfilePage from '@pages/DataBase/AppProfiles/AppProfilePage';
import AppProfiles from '@pages/DataBase/AppProfiles/AppProfiles';

import DeliveryChains from '@pages/DataBase/DeliveryChains/DeliveryChains';
import DeliveryChainPage from '@pages/DataBase/DeliveryChains/DeliveryChainPage';

import ChannelPage from '@pages/DataBase/Channels/ChannelPage';
import ChannelsPage from '@pages/DataBase/Channels/Channels';

import IndicatorPage from '@pages/DataBase/Status/IndicatorType/IndicatorPage';

//Rulesets
import RulesetPage from '@pages/DataBase/Rules/RulesetPage';
import Rulesets from '@pages/DataBase/Rules/Rulesets';
//Licenses
import LicensePage from '@pages/DataBase/Licenses/LicensePage';
import Licenses from '@pages/DataBase/Licenses/Licenses';

//Others
import Documents from '@pages/DataBase/Documents/Documents';
import UnitPage from '@pages/DataBase/Units/UnitPage';

import ParameterPage from '@pages/DataBase/Parameters/ParameterPage';
import AllocationsCheck from '@pages/DataBase/AllocationCheck/AllocationsCheck';
import DocumentPage from '@pages/DataBase/Documents/DocumentPage';
import WarningRuleStepper from '@pages/DataBase/Warnings/Stepper/WarningRuleStepper';
import WarningRules from '@pages/DataBase/Warnings/WarningRules';
import Entities from '@pages/DataBase/Entities/Entities';
import EventTypes from '@pages/DataBase/EventTypes/EventTypes';
import TaskTypes from '@pages/DataBase/TaskTypes/TaskTypes';
import Labels from '@pages/DataBase/Configuration/Labels/Labels';
import LabelPage from '@pages/DataBase/Configuration/Labels/LabelPage';
import Categories from '@pages/DataBase/Configuration/Categories/Categories';
import IndicatorTypes from '@pages/DataBase/Status/StatusIndicators';
import CategoryPage from '@pages/DataBase/Configuration/Categories/CategoryPage';
import GroupsTemplate from '@pages/DataBase/GroupTemplate/GroupTemplates';
import GroupTemplatePage from '@pages/DataBase/GroupTemplate/GroupTemplatePage';
import ContactDataPage from '@pages/DataBase/ContactData/ContactDataPage';
import TaskItems from '@pages/DataBase/Tasks/TaskItems';
import DeviceTypePage from '@pages/DataBase/DeviceTypes/DeviceTypePage';
import DeviceTypes from '@pages/DataBase/DeviceTypes/DeviceTypes';

//#region CRUD
const crudEntitiesData: ICrudRoute[] = [
  //Entities
  {
    aclId: 'tsEntity',
    entityName: 'entity',
    DataTable: Entities,
    FormPage: null,
    customEntityName: { table: 'entities', matchPath: '/entities' },

    //customTitle: { new: 'New warning rule', edit: 'Edit warning rule', table: 'Warning rules' },
  },
  //GroupTemplate
  {
    aclId: 'GroupTemplate',
    entityName: 'groupTemplate',
    DataTable: GroupsTemplate,
    FormPage: GroupTemplatePage,
    customTitle: { new: 'New group template', edit: 'Edit group template', table: 'Groups template' },
  },
  //WarningRules
  {
    aclId: 'WarningRule',
    entityName: 'warningRule',
    DataTable: WarningRules,
    FormPage: WarningRuleStepper,
    customTitle: { new: 'New warning rule', edit: 'Edit warning rule', table: 'Warning rules' },
  },
  //AllocationCheck
  {
    aclId: 'AllocationCheck',
    entityName: 'allocationCheck',
    DataTable: AllocationsCheck,
    FormPage: null,
  },
  //Parameter
  { aclId: 'taParameter', entityName: 'parameter', DataTable: null, FormPage: ParameterPage },
  //Ruleset
  { aclId: 'tsRuleset', entityName: 'ruleset', DataTable: Rulesets, FormPage: RulesetPage },
  //License
  { aclId: 'tsLicense', entityName: 'license', DataTable: Licenses, FormPage: LicensePage },
  //TaskType
  {
    aclId: 'taTaskType',
    entityName: 'taskType',
    DataTable: TaskTypes,
    FormPage: TaskTypePage,
    customTitle: { table: 'Task Types' },
  },
  //Task
  { aclId: 'taTask', entityName: 'task', DataTable: Tasks, FormPage: TaskPage, canFilter: true },

  //IndicatorTypes
  {
    aclId: 'indicatorType',
    entityName: 'indicator',
    DataTable: IndicatorTypes,
    customEntityName: 'indicatorTypes',
    FormPage: IndicatorPage,
  },
  //Documents
  { aclId: 'taDocument', entityName: 'document', DataTable: Documents, FormPage: DocumentPage },
  //Images
  { aclId: 'taDocument', entityName: 'image', DataTable: Documents, FormPage: DocumentPage },
  //Units
  { aclId: 'unit', entityName: 'unit', DataTable: null, FormPage: UnitPage },
  //Channel
  { aclId: 'Channel', entityName: 'channel', DataTable: ChannelsPage, FormPage: ChannelPage },
  //Events
  {
    aclId: 'taEvent',
    entityName: 'event',
    DataTable: Events,
    FormPage: EventPage,
    customId: { table: 'events' },
  },
  //Labels
  {
    aclId: 'tag',
    entityName: 'label',
    DataTable: Labels,
    FormPage: LabelPage,
  },

  //Categories
  {
    aclId: 'Category',
    entityName: 'category',
    customEntityName: 'categories',
    DataTable: Categories,
    FormPage: CategoryPage,
  },
  //EventType
  {
    aclId: 'taEventType',
    entityName: 'eventType',
    DataTable: Events,
    FormPage: EventTypePage,
    customEntityName: { matchPath: '/events/type/:logicalId', table: 'Events' },
    customId: { table: 'eventsByType' },
  },
  {
    aclId: 'taEventType',
    entityName: 'eventType',
    DataTable: EventTypes,
    FormPage: EventTypePage,
    customTitle: { table: 'Event types' },
  },
  //EventGenerationRule
  {
    aclId: 'taEventGenerationRule',
    entityName: 'eventGenerationRule',
    DataTable: Events,
    FormPage: EventGenerationRulePage,
    customTitle: { new: 'New event generation rules', edit: 'Edit event generation rules', table: 'Event generation rules' },
  },
  //DeliveryChain
  { aclId: 'DeliveryChain', entityName: 'deliveryChain', DataTable: DeliveryChains, FormPage: DeliveryChainPage },
  //Role
  { aclId: 'taRole', entityName: 'role', DataTable: Roles, FormPage: RolePage, canFilter: true },
  //ACL
  { aclId: 'taXUsersRoles', entityName: 'acl', DataTable: Acls, FormPage: AclPage },
  {
    aclId: 'taXUsersRoles',
    entityName: 'organizationAcl',
    DataTable: Acls,
    FormPage: AclPage,
    customTitle: { table: 'Organization Acls' },
  },
  //AclPrivilege
  { aclId: 'taAclPrivileges', entityName: 'aclPrivilege', DataTable: null, FormPage: ACLPrivilegePage },
  //Organization
  {
    aclId: 'taOrganization',
    entityName: 'organization',
    DataTable: Organizations,
    FormPage: { edit: OrganizationPage, new: OrganizationStepper, view: OrganizationPage },
  },
  //User
  { aclId: 'taUser', entityName: 'user', DataTable: Users, FormPage: UserPage, canFilter: true },
  { aclId: 'taUser', entityName: 'assignee', DataTable: Users, FormPage: UserPage, canFilter: true },
  //Address
  { aclId: 'taAddress', entityName: 'address', DataTable: null, FormPage: AddressPage },
  //ContactData
  { aclId: 'ContactData', entityName: 'contactData', DataTable: null, FormPage: ContactDataPage },
  //AppProfiles
  {
    aclId: 'taProfile',
    entityName: 'appProfile',
    DataTable: AppProfiles,
    FormPage: AppProfilePage,
    customTitle: { edit: 'Edit app profile', new: 'New app profile', view: 'View app profile' },
  },
  //DeviceType
  {
    aclId: 'taDeviceType',
    entityName: 'deviceType',
    DataTable: DeviceTypes,
    FormPage: DeviceTypePage,
  },
];
//#endregion

//#region DataBase
const databaseRoutes: IRoute[] = [
  //Tasks
  {
    id: 'taskItems',
    matchPath: '/taskItems/:id',
    pageComponent: TaskItems,
    pageTitle: 'Task Items',
    aclId: 'tsElement',
  },
  {
    id: 'tasks',
    matchPath: '/tasks/type/:logicalId/:status?',
    pageComponent: Tasks,
    pageTitle: 'Tasks',
    aclId: 'taTask',
    canFilter: true,
  },
  //EventGenerationRules
  {
    id: 'eventGenerationRuleNew',
    matchPath: '/itemType/:id/eventRule/new',
    pageComponent: EventGenerationRulePage,
    pageTitle: 'New event generation rule',
    aclId: 'taEventGenerationRule',
  },
  {
    id: 'eventGenerationRuleEdit',
    matchPath: '/itemType/:id/eventRule/:id/edit',
    pageComponent: EventGenerationRulePage,
    pageTitle: 'Edit event generation rule',
    aclId: 'taEventGenerationRule',
  },
  {
    id: 'eventGenerationRuleView',
    matchPath: 'itemType/:id/eventRule/:id/view',
    pageComponent: EventGenerationRulePage,
    pageTitle: 'View event generation rule',
    aclId: 'taEventGenerationRule',
  },
  //Roles
  {
    id: 'myRoles',
    matchPath: '/myroles',
    pageComponent: MyRoles,
    pageTitle: 'My roles',
    aclId: 'taRole',
  },
  {
    id: 'roleCopy',
    matchPath: '/role/copy',
    pageComponent: RolePage,
    pageTitle: 'Copy role',
    aclId: 'taRole',
  },
];
//#endregion

export default [...databaseRoutes, ...generateCRUDRoutes(crudEntitiesData)];
